<div
  *ngIf="loginService.premissions && loginService.premissions.uploadDocuments && showDeleteAlert"
  class="print-history-popup"
  style="z-index: 9999999"
>
  <div class="print-history-popup-body">
    <h2 class="popup-title">
      {{
        ("GUI.documents.labels.Delete" | translate) +
          toDeleteDocument.title +
          ("GUI.documents.labels.document from" | translate) +
          (toDeleteDocument.CreationTime | date : "d/M/yy, HH:mm a")
      }}?
    </h2>
    <div style="display: flex; justify-content: space-around">
      <button (click)="deleteDocument()">{{ "GUI.documents.labels.Yes" | translate }}</button>
      <button (click)="toDeleteDocument = null; showDeleteAlert = false" style="margin-left: 2em">
        {{ "GUI.documents.labels.No" | translate }}
      </button>
    </div>
    <button
      (click)="showDeleteAlert = false; toDeleteDocument = null"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
  </div>
</div>

<div class="wrapper" [dir]="this.lang.getPageDirection()">
  <div class="m-box">
    <h2>
      {{ patientService.currentPatient?.isBusinessClient ? ("appointments.gui.labels.Client Details" | translate) : ("appointments.gui.labels.Patient Details" | translate) }}
    </h2>
    <div style="display: flex; flex-direction: row">
      <div class="w50 warp">
        <div class="w50">
          <label class="label"> 
            {{ patientService.currentPatient?.isBusinessClient ? ("appointments.gui.labels.Business Client" | translate) : ("appointments.gui.labels.First Name" | translate) }}: 
          </label>
          <span>{{ patientService.currentPatient.First }}</span>
        </div>
        <div class="w50" *ngIf="!patientService.currentPatient?.isBusinessClient">
          <label class="label"> {{ "appointments.gui.labels.Last Name" | translate }}: </label>
          <span>{{ patientService.currentPatient.Last }}</span>
        </div>
        <div class="w50">
          <label class="label">
            {{
              patientService.currentPatient?.isBusinessClient
                ? ("GUI.Patients.BN ID Number" | translate) + ":"
                : patientService.currentPatient.IsID === 1
                ? ("appointments.gui.labels.ID" | translate) + ":"
                : ("appointments.gui.labels.Passport" | translate) + ":"
            }}
          </label>
          <span> {{ patientService.currentPatient.ID }} </span>
        </div>
        <div class="w50">
          <label class="label"> {{ "appointments.gui.labels.Mobile" | translate }}: </label>
          <span> {{ patientService.currentPatient.Mobile }}</span>
        </div>
        <div class="w50" *ngIf="!patientService.currentPatient?.isBusinessClient">
          <label class="label"> {{ "appointments.gui.labels.Birth Date" | translate }}: </label>
          <span> {{ patientService.currentPatient.Birth | date : "dd.MM.yyyy" }} </span>
        </div>
        <div class="w50" *ngIf="!patientService.currentPatient?.isBusinessClient">
          <label class="label"> {{ "appointments.gui.labels.Age" | translate }}: </label>
          <span> {{ patientService.getAgeMo() }} </span>
        </div>
        <div class="w50">
          <label class="label"> {{ "appointments.gui.labels.Email" | translate }}: </label>
          <span> {{ patientService.currentPatient.Email }} </span>
        </div>
        <div class="w50" *ngIf="!patientService.currentPatient?.isBusinessClient">
          <label class="label"> {{ "appointments.gui.labels.HMO" | translate }}: </label>
          <span>
            <ng-container *ngIf="patientService.currentPatient.HMO">
              {{ "appointments.gui.selects." + patientService.currentPatient.HMO | translate }}
            </ng-container>
          </span>
        </div>
        <div class="w50" *ngIf="!patientService.currentPatient?.isBusinessClient">
          <label class="label"> {{ "appointments.gui.labels.Insurance" | translate }}: </label>
          <span>
            <ng-container *ngIf="patientService.currentPatient.Insurance">
              {{ "appointments.gui.selects." + patientService.currentPatient.Insurance | translate }}
            </ng-container>
          </span>
        </div>
        <div class="w50" *ngIf="loginService.isObgyn && !patientService.currentPatient?.isBusinessClient">
          <label class="label"> {{ "appointments.gui.labels.LMP" | translate }}: </label>
          <span> {{ patientService.currentPatient.LMP | date : "dd.MM.yyyy" }} </span>
        </div>
      </div>
      <div>
        <button class="blue-btn" (click)="editPat = true">
          {{ patientService.currentPatient?.isBusinessClient ? ("appointments.gui.buttons.Edit Client" | translate) : ("appointments.gui.buttons.Edit Patient" | translate) }}
        </button>
      </div>
    </div>
    <div>
      <ng-container *ngIf="!isBilling">
        <hr class="divider" />
        <mat-tab-group animationDuration="0ms" [selectedIndex]="upcomingAppointments.length > 0 ? 0 : 1">
          <!-- ========== Upcoming Appointmetns (Start) ========== -->
          <mat-tab>
            <ng-template mat-tab-label>
              <span
                [matBadge]="upcomingAppointments.length"
                matBadgeOverlap="false"
                [matBadgeHidden]="upcomingAppointments.length === 0 ? true : false"
              >
                {{ "appointments.gui.buttons.Upcoming Appointments" | translate }}
              </span>
            </ng-template>
            <ng-container *ngIf="upcomingAppointments.length === 0">
              <div style="display: flex; justify-content: center; align-items: center">
                <h5>{{ "appointments.gui.labels.There are no upcoming appointments" | translate }}</h5>
              </div>
            </ng-container>
            <ng-container *ngIf="upcomingAppointments.length > 0">
              <table style="margin-top: 0; margin-bottom: 2em" *ngIf="upcomingAppointments.length">
                <thead *ngIf="getUpcomingAppointmentsSummary() as summary">
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th *ngIf="!loginService?.premissions?.ApptsByRoom"></th>
                    <th *ngIf="loginService?.premissions?.ApptsByRoom"></th>
                    <th>{{ summary.arrived }} / {{ summary.total }}</th>
                    <th>{{ summary.confirmed }} / {{ summary.total }}</th>
                    <!-- <th>{{ summary.changes }} / {{ summary.total }}</th> -->
                    <th></th>
                    <th *ngIf="hasTodayAppointments()"></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>#</th>
                    <th>
                      {{ "appointments.gui.labels.Appointment type" | translate | titlecase }}
                    </th>
                    <th>
                      {{ "appointments.gui.labels.Date" | translate }}
                    </th>
                    <th>
                      {{ "appointments.gui.labels.appointment duration" | translate | titlecase }}
                    </th>
                    <th *ngIf="!loginService?.premissions?.ApptsByRoom">
                      {{ "appointments.gui.labels.Doctor" | translate | titlecase }}
                    </th>
                    <th *ngIf="loginService?.premissions?.ApptsByRoom">
                      {{ "appointments.gui.labels.exam room" | translate | titlecase }}
                    </th>
                    <th>{{ "appointments.gui.labels.app done" | translate | titlecase }}</th>
                    <th>{{ "appointments.gui.labels.confirm Arrive" | translate | titlecase }}</th>
                    <th>{{ "appointments.gui.labels.Patient Arrival" | translate }}</th>
                    <th></th>
                    <th *ngIf="hasTodayAppointments()"></th>
                    <th>{{ "appointments.gui.labels.Comments" | translate }}</th>
                    <th>{{ "appointments.gui.labels.creation time" | translate }}</th>
                    <th>{{ "appointments.gui.placeholders.no_pat_arrival" | translate }}</th>
                    <th>{{ "appointments.gui.placeholders.no_appt_reason" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let appointment of upcomingAppointments | sortByDateTime; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td
                      [ngClass]="{
                        'clickable-td': (examTypeChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'examTypeID')"
                    >
                      {{ appointment.isCustom ? appointment.examType : appointment.examName }}
                    </td>
                    <td
                      class="date-cell"
                      [ngClass]="{
                        'clickable-td': (upcomingDateChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'aptTime')"
                    >
                      {{ appointment.aptTime | date : "dd.MM.yyyy" }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (durationChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'aptlength')"
                    >
                      {{ appointment.aptTime | date : "HH:mm" }} -
                      {{ appointment.aptEndTime | date : "HH:mm" }} ({{ appointment.aptlength }}
                      {{ "appointments.gui.labels.min" | translate }})
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (doctorChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'DocUID')"
                      *ngIf="!loginService?.premissions?.ApptsByRoom"
                    >
                      {{ appointment.docName }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (roomChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'RID')"
                      *ngIf="loginService?.premissions?.ApptsByRoom"
                    >
                      {{ appointment.roomName }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (completedChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'completed')"
                    >
                      {{ handleCompletedText(appointment) | titlecase }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (arrivalConfirmCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'arrivalConfirm')"
                    >
                      {{ handleArrivalText(appointment) | titlecase }}
                    </td>
                    <td>
                      {{ handlePatientArrivalText(appointment) | titlecase }}
                    </td>
                    <!-- <td
                      [ngClass]="{
                        'clickable-td': (upcomingDateChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      (click)="openDialog(appointment, upcomingDateChangesCounts[appointment.AutoIndex])"
                    >
                      {{ upcomingDateChangesCounts[appointment.AutoIndex] || 0 }}
                    </td> -->
                    <td>
                      <button class="blue-btn fit-height" (click)="editAppointment(appointment)">
                        {{ "appointments.gui.buttons.Edit Appointment" | translate }}
                      </button>
                    </td>
                    <td *ngIf="isToday(appointment.aptTime)">
                      <button
                        class="blue-btn fit-height"
                        (click)="
                          updateArrival(appointment.AutoIndex, appointment.Arrived ? false : true)
                        "
                      >
                        {{
                          appointment.Arrived
                            ? ("appointments.gui.buttons.Cancel Arrival" | translate)
                            : ("appointments.gui.buttons.Patient Arrival" | translate)
                        }}
                      </button>
                    </td>
                    <td>
                      {{ appointment.comment }}
                    </td>
                    <td>
                      {{ appointment.createdDate | date : "dd/MM/yy, HH:mm" }}
                    </td>
                    <td>
                      {{ appointment.patientNoArrivalReason }}
                    </td>
                    <td>
                      {{ appointment.noExamReason }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </mat-tab>
          <!-- ========== Upcoming Appointmetns (End) ========== -->

          <!-- ========== Previous Appointmetns (Start) ========== -->
          <mat-tab>
            <ng-template mat-tab-label>
              <span
                [matBadge]="previousAppointments.length"
                matBadgeOverlap="false"
                [matBadgeHidden]="previousAppointments.length === 0 ? true : false"
              >
                {{ "appointments.gui.buttons.Previous Appointments" | translate }}
              </span>
            </ng-template>
            <ng-container *ngIf="previousAppointments.length === 0">
              <div style="display: flex; justify-content: center; align-items: center">
                <h5>{{ "appointments.gui.labels.There are no previous appointments" | translate }}</h5>
              </div>
            </ng-container>
            <ng-container *ngIf="previousAppointments.length > 0">
              <table style="margin-top: 0">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th *ngIf="!loginService?.premissions?.ApptsByRoom"></th>
                    <th *ngIf="loginService?.premissions?.ApptsByRoom"></th>
                    <th>
                      {{ getPreviousAppointmentsSummary().arrived }} /
                      {{ getPreviousAppointmentsSummary().total }}
                    </th>
                    <th>
                      {{ getPreviousAppointmentsSummary().confirmed }} /
                      {{ getPreviousAppointmentsSummary().total }}
                    </th>
                    <!-- <th>
                      {{ getPreviousAppointmentsSummary().changes }} /
                      {{ getPreviousAppointmentsSummary().total }}
                    </th> -->
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>#</th>
                    <th>
                      {{ "appointments.gui.labels.Appointment type" | translate }}
                    </th>
                    <th>
                      {{ "appointments.gui.labels.Date" | translate }}
                    </th>
                    <th>
                      {{ "appointments.gui.labels.appointment duration" | translate }}
                    </th>
                    <th *ngIf="!loginService?.premissions?.ApptsByRoom">
                      {{ "appointments.gui.labels.Doctor" | translate | titlecase }}
                    </th>
                    <th *ngIf="loginService?.premissions?.ApptsByRoom">
                      {{ "appointments.gui.labels.exam room" | translate | titlecase }}
                    </th>
                    <th>{{ "appointments.gui.labels.app done" | translate | titlecase }}</th>
                    <th>{{ "appointments.gui.labels.confirm Arrive" | translate | titlecase }}</th>
                    <th>{{ "appointments.gui.labels.Patient Arrival" | translate }}</th>
                    <th>{{ "appointments.gui.labels.Comments" | translate }}</th>
                    <th>{{ "appointments.gui.labels.creation time" | translate }}</th>
                    <th>{{ "appointments.gui.placeholders.no_pat_arrival" | translate }}</th>
                    <th>{{ "appointments.gui.placeholders.no_appt_reason" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let appointment of previousAppointments | sortByDateTime; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td
                      [ngClass]="{
                        'clickable-td': (examTypeChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'examTypeID')"
                    >
                      {{ appointment.isCustom ? appointment.examType : appointment.examName }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (previousDateChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'aptTime')"
                    >
                      {{ appointment.aptTime | date : "dd.MM.yyyy" }}
                    </td>
                    <td>
                      {{ appointment.aptTime | date : "HH:mm" }}-{{
                        appointment.aptEndTime | date : "HH:mm"
                      }}
                      ({{ appointment.aptlength }} {{ "appointments.gui.labels.min" | translate }})
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (doctorChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'DocUID')"
                      *ngIf="!loginService?.premissions?.ApptsByRoom"
                    >
                      {{ appointment.docName }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (roomChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'RID')"
                      *ngIf="loginService?.premissions?.ApptsByRoom"
                    >
                      {{ appointment.roomName }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (durationChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'completed')"
                    >
                      {{ handleCompletedText(appointment) | titlecase }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (durationChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'arrivalConfirm')"
                    >
                      {{ handleArrivalText(appointment) | titlecase }}
                    </td>
                    <td>
                      {{ handlePatientArrivalText(appointment) | titlecase }}
                    </td>
                    <!-- <td
                      [ngClass]="{
                        'clickable-td': (previousDateChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      (click)="openDialog(appointment, previousDateChangesCounts[appointment.AutoIndex])"
                    >
                      {{ previousDateChangesCounts[appointment.AutoIndex] || 0 }}
                    </td> -->
                    <td>
                      {{ appointment.comment }}
                    </td>
                    <td>
                      {{ appointment.createdDate | date : "dd/MM/yy, HH:mm" }}
                    </td>
                    <td>
                      {{ appointment.patientNoArrivalReason }}
                    </td>
                    <td>
                      {{ appointment.noExamReason }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </mat-tab>
          <!-- ========== Previous Appointmetns (End) ========== -->

          <!-- ========== Canceled Appointmetns (Start) ========== -->
          <mat-tab>
            <ng-template mat-tab-label>
              <span
                [matBadge]="canceledAppointments.length"
                matBadgeOverlap="false"
                [matBadgeHidden]="canceledAppointments.length === 0 ? true : false"
              >
                {{ "appointments.gui.buttons.canceled appointments" | translate }}
              </span>
            </ng-template>
            <ng-container *ngIf="canceledAppointments.length === 0">
              <div style="display: flex; justify-content: center; align-items: center">
                <h5>{{ "appointments.gui.labels.There are no canceled appointments" | translate }}</h5>
              </div>
            </ng-container>
            <ng-container *ngIf="canceledAppointments.length > 0">
              <table style="margin-top: 0">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th *ngIf="!loginService?.premissions?.ApptsByRoom"></th>
                    <th *ngIf="loginService?.premissions?.ApptsByRoom"></th>
                    <th>
                      {{ getCanceledAppointmentsSummary().arrived }} /
                      {{ getCanceledAppointmentsSummary().total }}
                    </th>
                    <th>
                      {{ getCanceledAppointmentsSummary().confirmed }} /
                      {{ getCanceledAppointmentsSummary().total }}
                    </th>
                    <!-- <th>
                      {{ getCanceledAppointmentsSummary().changes }} /
                      {{ getCanceledAppointmentsSummary().total }}
                    </th> -->
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>#</th>
                    <th>
                      {{ "appointments.gui.labels.Appointment type" | translate }}
                    </th>
                    <th>
                      {{ "appointments.gui.labels.Date" | translate }}
                    </th>
                    <th>
                      {{ "appointments.gui.labels.appointment duration" | translate }}
                    </th>
                    <th *ngIf="!loginService?.premissions?.ApptsByRoom">
                      {{ "appointments.gui.labels.Doctor" | translate | titlecase }}
                    </th>
                    <th *ngIf="loginService?.premissions?.ApptsByRoom">
                      {{ "appointments.gui.labels.exam room" | translate | titlecase }}
                    </th>
                    <th>{{ "appointments.gui.labels.app done" | translate | titlecase }}</th>
                    <th>{{ "appointments.gui.labels.confirm Arrive" | translate | titlecase }}</th>
                    <th>{{ "appointments.gui.labels.Patient Arrival" | translate }}</th>
                    <th>{{ "appointments.gui.labels.Deleted by" | translate }}</th>
                    <th>{{ "appointments.gui.labels.Deleted Date" | translate }}</th>
                    <th>{{ "appointments.gui.labels.Comments" | translate }}</th>
                    <th>{{ "appointments.gui.labels.creation time" | translate }}</th>
                    <th>{{ "appointments.gui.placeholders.no_pat_arrival" | translate }}</th>
                    <th>{{ "appointments.gui.placeholders.no_appt_reason" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let appointment of canceledAppointments | sortByDateTime; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td
                      [ngClass]="{
                        'clickable-td': (examTypeChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'examTypeID')"
                    >
                      {{ appointment.isCustom ? appointment.examType : appointment.examName }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (canceledDateChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'aptTime')"
                    >
                      {{ appointment.aptTime | date : "dd.MM.yyyy" }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (canceledDateChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'aptlength')"
                    >
                      {{ appointment.aptTime | date : "HH:mm" }}-{{
                        appointment.aptEndTime | date : "HH:mm"
                      }}
                      ({{ appointment.aptlength }} {{ "appointments.gui.labels.min" | translate }})
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (doctorChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'DocUID')"
                      *ngIf="!loginService?.premissions?.ApptsByRoom"
                    >
                      {{ appointment.docName }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (roomChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'RID')"
                      *ngIf="loginService?.premissions?.ApptsByRoom"
                    >
                      {{ appointment.roomName }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (durationChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'completed')"
                    >
                      {{ handleCompletedText(appointment) | titlecase }}
                    </td>
                    <td
                      [ngClass]="{
                        'clickable-td': (durationChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      matTooltip="{{ 'appointments.gui.tooltips.Click for more info' | translate }}"
                      (click)="openDialog(appointment, 'arrivalConfirm')"
                    >
                      {{ handleArrivalText(appointment) | titlecase }}
                    </td>
                    <td>
                      {{ handlePatientArrivalText(appointment) | titlecase }}
                    </td>
                    <!-- <td
                      [ngClass]="{
                        'clickable-td': (canceledDateChangesCounts[appointment.AutoIndex] || 0) > 0
                      }"
                      (click)="openDialog(appointment, canceledDateChangesCounts[appointment.AutoIndex])"
                    >
                      {{ canceledDateChangesCounts[appointment.AutoIndex] || 0 }}
                    </td> -->
                    <td>
                      {{
                        appointment.DeletedByUserName
                          ? appointment.DeletedByUserName
                          : ("appointments.gui.labels.by patient" | translate)
                      }}
                    </td>
                    <td>
                      {{ appointment.DELETED | date : "dd/MM/yy, HH:mm" }}
                    </td>
                    <td>
                      {{ appointment.comment }}
                    </td>
                    <td>
                      {{ appointment.createdDate | date : "dd/MM/yy, HH:mm" }}
                    </td>
                    <td>
                      {{ appointment.patientNoArrivalReason }}
                    </td>
                    <td>
                      {{ appointment.noExamReason }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </mat-tab>
          <!-- ========== Canceled Appointmetns (End) ========== -->
        </mat-tab-group>

        <hr class="divider" />

        <div style="display: flex">
          <!-- <button
            class="blue-btn"
            (click)="showCanceledAppts = !showCanceledAppts; showPrevious = false"
          >
            {{ "appointments.gui.buttons.canceled appointments" | translate }}
          </button> -->
          <!-- <button class="blue-btn" (click)="showPrevious = !showPrevious; showCanceledAppts = false">
            {{ "appointments.gui.buttons.Previous Appointments" | translate }}
          </button> -->
          <button class="blue-btn" (click)="setPage('Calendar')">
            {{ "appointments.gui.buttons.Schedule New Appointment" | translate }}
          </button>
          <button
            *ngIf="this.loginService.premissions.sendWhatsappMsg"
            class="blue-btn"
            (click)="openSendWhatsappDialog(this.patientService.currentPatient)"
          >
            {{ "messages.table.buttons.send_new_msg" | translate }}
          </button>
           <button
           *ngIf="patientService.currentPatient && appointmentService.appointmentToNavBack"
            class="blue-btn"
            (click)="navToLastAppt()"
          >
            {{ "appointments.gui.buttons.back to appointment" | translate }}
          </button>

          <div
            *ngIf="loginService.premissions && loginService.premissions.PreSelectExam"
            style="display: flex"
          >
            <button class="blue-btn" (click)="showExamList = true">
              {{ "appointments.gui.buttons.Smart Scheduler" | translate }}
            </button>
            <ng-container *ngIf="showExamList">
              <div class="w50" [formGroup]="appointmentForm">
                <div class="l-flex l-flex-c t-field t-field-pad" style="width: fit-content">
                  <div class="l-flex-c t-field t-twin-fieldset t-fieldset-big" style="direction: ltr;">
                    <label>
                      <input
                        type="radio"
                        name="custom"
                        class="custom-check"
                        formControlName="custom"
                        [value]="0"
                      />
                      <i class="customInput-display"></i>
                      <span>
                        {{ "appointments.gui.labels.AWEB Exams" | translate }}
                      </span>
                    </label>

                    <label>
                      <input
                        type="radio"
                        name="custom"
                        class="custom-check"
                        formControlName="custom"
                        [value]="1"
                      />
                      <i class="customInput-display"></i>
                      <span>
                        {{ "appointments.gui.labels.Other" | translate }}
                      </span>
                    </label>
                  </div>
                  <i class="t-sep"></i>
                  <select
                    *ngIf="!appointmentForm.get('custom').value"
                    class="t-select w100"
                    style="padding-left: 1vh; width: fit-content"
                    [(ngModel)]="selectedExam"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="navToSchedule($event)"
                  >
                    <option *ngFor="let exam of examsTypes" [value]="exam.AutoIndex">
                      {{ exam.examName }}
                    </option>
                  </select>
                  <select
                    *ngIf="appointmentForm.get('custom').value"
                    class="t-select w100"
                    style="padding-left: 1vh; width: fit-content"
                    [(ngModel)]="selectedExam"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="navToSchedule($event)"
                  >
                    <option *ngFor="let exam of customExamTypes" [value]="exam.AutoIndex">
                      {{ exam.examType }}
                    </option>
                  </select>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="isBilling">
      <app-invoice [currentPatient]="patientService.currentPatient"></app-invoice>
    </ng-container>

    <ng-container *ngIf="loginService.premissions && loginService.premissions.uploadDocuments">
      <hr class="divider" />
      <h3>{{ "GUI.documents.labels.Attached Documents" | translate }}</h3>
      <div>
        <h4>{{ "GUI.documents.labels.Administration" | translate }}:</h4>
        <div class="l-flex patient-item-n" *ngFor="let document of adminDocuments; index as i">
          <button class="w100" style="cursor: pointer">
            <div class="l-table h100">
              <span
                class="l-td-m patient-item-cell"
                style="width: 5em"
                (click)="openDocument(document.AutoIndex)"
              >
                <strong>{{ i + 1 }}</strong>
              </span>
              <span class="l-td-m patient-item-cell">
                <strong> {{ "GUI.documents.labels.name" | translate }}: </strong> {{ document.title }}
              </span>

              <span class="l-td-m patient-item-cell" (click)="openDocument(document.AutoIndex)">
                <strong> {{ "GUI.documents.labels.file type" | translate }}: </strong>
                {{ document.fileType }}
              </span>
              <span class="l-td-m patient-item-cell" (click)="openDocument(document.AutoIndex)">
                <strong> {{ "GUI.documents.labels.comment" | translate }}: </strong>
                {{ document.comments }}
              </span>
              <span class="l-td-m patient-item-cell" (click)="openDocument(document.AutoIndex)">
                <strong> {{ "GUI.documents.labels.creation time" | translate }}: </strong>
                {{ document.CreationTime | date : "dd/MM/yyyy" }}
              </span>

              <span class="l-td-m patient-item-cell w5">
                <img
                  style="cursor: pointer"
                  matTooltip="{{ 'GUI.documents.tooltips.Delete Document' | translate }}"
                  height="35em"
                  src="../../assets/icons/delete-blue.svg"
                  (click)="showDeleteAlert = true; toDeleteDocument = document"
                />
              </span>
            </div>
          </button>
        </div>

        <h4>{{ "GUI.documents.labels.Clinical" | translate }}:</h4>
        <div class="l-flex patient-item-n" *ngFor="let document of documents; index as i">
          <button class="w100" style="cursor: pointer">
            <div class="l-table h100">
              <span
                class="l-td-m patient-item-cell"
                style="width: 5em"
                (click)="openDocument(document.AutoIndex)"
              >
                <strong>{{ i + 1 }}</strong>
              </span>
              <span class="l-td-m patient-item-cell">
                <strong> {{ "GUI.documents.labels.name" | translate }}: </strong> {{ document.title }}
              </span>

              <span class="l-td-m patient-item-cell" (click)="openDocument(document.AutoIndex)">
                <strong> {{ "GUI.documents.labels.file type" | translate }}: </strong>
                {{ document.fileType }}
              </span>
              <span class="l-td-m patient-item-cell" (click)="openDocument(document.AutoIndex)">
                <strong> {{ "GUI.documents.labels.comment" | translate }}: </strong>
                {{ document.comments }}
              </span>
              <span class="l-td-m patient-item-cell" (click)="openDocument(document.AutoIndex)">
                <strong> {{ "GUI.documents.labels.creation time" | translate }}: </strong>
                {{ document.CreationTime | date : "dd/MM/yyyy" }}
              </span>

              <span class="l-td-m patient-item-cell w5">
                <img
                  style="cursor: pointer"
                  matTooltip="{{ 'GUI.documents.tooltips.Delete Document' | translate }}"
                  height="35em"
                  src="../../assets/icons/delete-blue.svg"
                  (click)="showDeleteAlert = true; toDeleteDocument = document"
                />
              </span>
            </div>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<app-patdetails *ngIf="editPat" (closed)="editPat = false" [page]="'Patients'"></app-patdetails>
<app-appointment
  *ngIf="showAppointment"
  [event]="selectedEventInfo"
  (closed)="closeAppointment()"
  (viewCalendar)="onViewCalendar($event)"
></app-appointment>
